import { createSlice } from "@reduxjs/toolkit";
import { addStationsAPI } from "../../actions/stations/addStations";

const initialState = {
  addStation: {},
  loading: false,
  error: { code: "", message: "" },
};

const addStationsSlice = createSlice({
  name: "addStation",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addStationsAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStationsAPI.fulfilled, (state, action) => {
        state.addStation = action.payload.data;
        state.loading = false;
      })
      .addCase(addStationsAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { resetUserData } = addStationsSlice.actions;
export default addStationsSlice.reducer;
